<template>
  <nav v-if="pagination && pagination.to && pagination.to > 1" class="flex items-center space-x-4 justify-between px-4 py-3 sm:px-6" aria-label="Pagination">
    <div class="hidden sm:block">
      <p class="text-sm text-gray-700">
        pagina
        {{ ' ' }}
        <span class="font-medium">{{ pagination.currentPage }}</span>
        {{ ' ' }}
        di
        {{ ' ' }}
        <span class="font-medium">{{ pagination.pages }}</span>
      </p>
    </div>
    <div class="hidden sm:block">
      <p class="text-sm text-gray-700">
        da
        {{ ' ' }}
        <span class="font-medium">{{ pagination.from }}</span>
        {{ ' ' }}
        a
        {{ ' ' }}
        <span class="font-medium">{{ pagination.to }}</span>
        {{ ' ' }}
        di
        {{ ' ' }}
        <span class="font-medium">{{ pagination.totalItems }}</span>
      </p>
    </div>
    <div class="flex flex-1 justify-between sm:justify-end">
      <a href="#" class="relative inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:outline-offset-0"
         v-if="pagination.currentPage > 1"
         @click.prevent="$emit('change', pagination.currentPage - 1)"
      >Prec.</a>
      <a href="#" class="relative ml-3 inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:outline-offset-0"
         v-if="pagination.currentPage < pagination.pages"
         @click.prevent="$emit('change', pagination.currentPage + 1)"
      >Succ.</a>
    </div>
  </nav>
</template>
<script setup>
import {computed} from 'vue'

const props = defineProps({
  paginationInfo: {
    type: Object,
    default: () => ({})
  }
})

const pagination = computed(() => {
  if (props.paginationInfo) {
    const {
      currentPage,
      pages,
      from,
      to,
      pageItems,
      totalItems
    } = props.paginationInfo
    return {
      currentPage,
      pages,
      from,
      to,
      pageItems,
      totalItems
    }
  }
  return {}
})

defineEmits([
  'change'
])

</script>
